<template>

    <form ref="estagioduracaominima-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="numeroMinimo">Quantidade Mínima de Alunos</label>
                <input type="number" class="form-control" min="0" name="numeroMinimo" placeholder="Quantidade Mínima de Alunos" v-model="model.numeroMinimo" required />
            </div>

            <div class="form-group col-md-12">
                <label for="numeroMaximo">Quantidade Máxima de Alunos</label>
                <input type="number" class="form-control" min="0" name="numeroMaximo" placeholder="Quantidade Máxima de Alunos" v-model="model.numeroMaximo" required />
            </div>

            <div class="form-group col-md-12">
                <label for="duracao">Duração</label>
                <input type="number" class="form-control" min="0" name="duracao" placeholder="Duração" v-model="model.duracao" required />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioduracaominima-form-create",
        mixins: [base],
        props: { estagioId: Number },
        data: () => ({

            model: {},

            form: "estagioduracaominima-form-create",
            
            resources: {
                create: 'estagioduracaominima',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;
                this.model.estagioId = this.estagioId;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

